export default "__VITE_ASSET__f97804ff__"